import { ThemeEvents, VariantUpdateEvent } from "@theme/events";
import { morph } from "@theme/morph";

/**
 * ProductStockNotice - Updates stock/pre-order notices when variant changes
 * Shows pre-order notice when variant is out of stock but allows backorders
 * Shows low-stock notice when variant has 1-3 items remaining
 */
class ProductStockNotice extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest(".shopify-section, dialog");
    closestSection?.addEventListener(
      ThemeEvents.variantUpdate,
      this.updateNotice,
    );
  }

  disconnectedCallback() {
    const closestSection = this.closest(".shopify-section, dialog");
    closestSection?.removeEventListener(
      ThemeEvents.variantUpdate,
      this.updateNotice,
    );
  }

  /**
   * Updates the stock notice based on variant change.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateNotice = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const newNotice = event.detail.data.html.querySelector(
      "product-stock-notice",
    );

    if (newNotice) {
      morph(this, newNotice, { childrenOnly: true });
    } else {
      // If no notice in new HTML, clear content
      this.innerHTML = "";
    }
  };
}

if (!customElements.get("product-stock-notice")) {
  customElements.define("product-stock-notice", ProductStockNotice);
}
